import React, { useState } from 'react';
import Modal from './Modal';

const TileGrid = ({ tiles }) => {
    const [modalData, setModalData] = useState({ isOpen: false, title: '', content: [], icon: '' });

    const openModal = (title, content, icon) => {
        setModalData({ isOpen: true, title, content, icon });
    };

    const closeModal = () => {
        setModalData({ isOpen: false, title: '', content: [], icon: '' });
    };

    return (
        <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {tiles.map((tile, index) => (
                    <div
                        key={index}
                        className={`
                            group relative rounded-2xl
                            bg-white shadow-xl border border-gray-100
                            p-6 sm:p-8 cursor-pointer 
                            transition-all duration-500 ease-out
                            hover:shadow-2xl hover:scale-[1.02] hover:bg-gray-50
                        `}
                        onClick={() => tile.modalContent && openModal(tile.title, tile.modalContent, tile.icon)}
                    >
                        {/* Content */}
                        <div className="relative z-10 flex flex-col h-full">
                            {tile.icon && (
                                <div className="text-4xl text-primary mb-4 text-center group-hover:scale-110 transition-transform duration-500">
                                    <i className={tile.icon}></i>
                                </div>
                            )}
                            
                            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center group-hover:text-primary transition-colors duration-300 break-words">
                                {tile.title}
                            </h3>
                            
                            <p className="text-base text-gray-600 text-center flex-grow leading-relaxed break-words mb-4">
                                {tile.content}
                            </p>
                            
                            {tile.modalContent && (
                                <div className="text-center mt-auto">
                                    <span className="inline-flex items-center text-primary font-semibold text-base hover:text-primary-dark transition-all duration-300 group-hover:translate-x-1">
                                        mehr erfahren
                                        <i className="ml-2 fas fa-arrow-right text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <Modal
                isOpen={modalData.isOpen}
                onClose={closeModal}
                title={modalData.title}
                content={modalData.content}
                icon={modalData.icon}
            />
        </>
    );
};

export default TileGrid; 